import {Block} from '../../models/Block';
import {ExpandedPart} from './ExpandedPartsProvider';
import {Part} from '../../models/Part';
import {v5} from 'uuid';

export class Expander {
    private NAMESPACE = '004d7934-12a2-11ea-8d71-362b9e155665';

    public expand(blocks: Block[]): ExpandedPart[] {
        return blocks.reduce((p: ExpandedPart[], block: Block) => {
            return [...p, ...this.toExpandedParts(block)];
        }, []);
    }

    private toExpandedParts(block: Block): ExpandedPart[] {
        return this.range(block.repeats).reduce((parts: ExpandedPart[], _: any, repetition: number) => {
            return [...parts, ...block.parts.map((part: Part) => this.toExpandedPart(block, repetition, part))];
        }, []);
    }

    private toExpandedPart(block: Block, repetition: number, part: Part): ExpandedPart {
        return {
            // The combination of the block UUID, part UUID and repetition is unique. Using v5 this
            // results in the same UUID independent of the time when it is rendered.
            __uuid: v5(block.__uuid + '|' + repetition + '|' + part.__uuid, this.NAMESPACE),
            part: part,
            block: block,
        };
    }

    private range(size: number) {
        return Array.apply(null, Array(size));
    }
}
